import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, {
    DocumentId,
    EndpointQueryParameters,
    StrapiCreate,
    StrapiSingle,
    StrapiUpdate,
} from '../../types/strapi/strapi'
import Receipt from '../../types/api/receipt'
import getQuery from '../../helpers/api/get-query'

export const receiptsApi = createApi({
    reducerPath: 'receiptsApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['Receipts'],
    endpoints: builder => ({
        getReceipts: builder.query<Strapi<Receipt>, EndpointQueryParameters | void>({
            query: getQuery('/receipts'),
            providesTags: ['Receipts'],
        }),
        getMyReceipts: builder.query<Strapi<Receipt>, EndpointQueryParameters | void>({
            query: getQuery('/receipts/my'),
            providesTags: ['Receipts'],
        }),

        getReceiptByDocId: builder.query<
            StrapiSingle<Receipt>,
            [string, EndpointQueryParameters | void]
        >({
            query: ([docId, params]) => getQuery(`/receipts/${docId}`)(params),
            providesTags: ['Receipts'],
        }),
        createReceipt: builder.mutation<StrapiSingle<Receipt>, StrapiCreate<Receipt>>({
            query: body => ({
                url: '/receipts',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Receipts'],
        }),
        updateReceipt: builder.mutation<StrapiSingle<Receipt>, StrapiUpdate<Receipt>>({
            query: ({ docId, body }) => ({
                url: `/receipts/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Receipts'],
        }),
        acceptReceipt: builder.mutation<any, DocumentId>({
            query: docId => ({
                url: `/receipt/${docId}/accept`,
                method: 'POST',
            }),
            invalidatesTags: ['Receipts'],
        }),
    }),
})

export const {
    useGetReceiptsQuery,
    useGetMyReceiptsQuery,
    useGetReceiptByDocIdQuery,
    useLazyGetReceiptByDocIdQuery,
    useCreateReceiptMutation,
    useUpdateReceiptMutation,
    useAcceptReceiptMutation,
} = receiptsApi
